import { Box, Divider, Text, HStack } from '@chakra-ui/layout';
import { Button, Tabs, TabList, TabPanels, TabPanel, Tab, Spinner } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GlobalTable } from '../../withdrawal/components/global-table-template';
import { syncDataPlans, getDataSubscription } from '../service';
import { DataSubscriptionTableBody } from './table-data/TableBody';
import { DataSubscriptionTableHead } from './table-data/TableHead';

const NETWORK_PROVIDERS = [
  { id: 'mtn', name: 'MTN', label: 'MTN' },
  { id: 'glo', name: 'GLO', label: 'GLO' },
  { id: 'airtel', name: 'Airtel', label: 'Airtel' },
  { id: '9mobile', name: '9mobile', label: '9mobile' }
];

export const DataSubscription = () => {
  const userId = useSelector((state) => state.auth.user);
  const [syncLoading, setSyncLoading] = useState(false);
  const [networkData, setNetworkData] = useState({});
  const [loadingStates, setLoadingStates] = useState({});
  const [activeTab, setActiveTab] = useState(0);

  const loadNetworkData = async (network) => {
    setLoadingStates(prev => ({ ...prev, [network.id]: true }));
    try {
      const data = await getDataSubscription(userId, network.id);
      setNetworkData(prev => ({
        ...prev,
        [network.id]: data
      }));
    } catch (error) {
      console.error(`Error loading ${network.name} data:`, error);
    } finally {
      setLoadingStates(prev => ({ ...prev, [network.id]: false }));
    }
  };

  useEffect(() => {
    // Load data for the active tab only
    const currentNetwork = NETWORK_PROVIDERS[activeTab];
    if (!networkData[currentNetwork.id]) {
      loadNetworkData(currentNetwork);
    }
  }, [activeTab]);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  return (
    <Box
      m='10px 0'
      p={['10px', '20px']}
      bg='#fff'
      boxShadow='md'
      borderRadius='5px'
    >
      <HStack justify='space-between' mb='10px'>
        <Text color='#8366A5'>
          <b>Data Subscription</b>
        </Text>
        <Button
          isLoading={syncLoading}
          onClick={() => syncDataPlans(userId, setSyncLoading)}
          color='#FF6F6F'
          variant='outline'
          size='xs'
        >
          Sync prices
        </Button>
      </HStack>
      <Divider />
      <Tabs variant='soft-rounded' colorScheme='purple' mt={4} index={activeTab} onChange={handleTabChange}>
        <TabList>
          {NETWORK_PROVIDERS.map((network, index) => (
            <Tab key={network.id}>{network.label}</Tab>
          ))}
        </TabList>
        <TabPanels>
          {NETWORK_PROVIDERS.map((network) => (
            <TabPanel key={network.id}>
              <Box h='300px' overflow='auto' position="relative">
                {loadingStates[network.id] ? (
                  <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                    <Spinner size="xl" color="purple.500" />
                  </Box>
                ) : (
                  <GlobalTable
                    tableHead={<DataSubscriptionTableHead />}
                    tableBody={<DataSubscriptionTableBody Data={networkData[network.id] || []} />}
                    striped={false}
                  />
                )}
              </Box>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
};
